import { DocumentType } from './../entities/documentType';
import { Employee } from 'app/core/entities/employee';
import { VoucherMain } from 'app/core/entities/voucher-main';
import { Injectable, Injector } from '@angular/core';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ExecutingUnit } from '../entities/executingUnit';
import { FiscalYear } from '../entities/fiscalYear';
import { Mhelpdesk } from '../entities/mhelpdesk';
import { Vendor } from '../entities/vendor';
import * as FileSaver from 'file-saver';
import { catchError, tap, map } from 'rxjs/operators';
import { VoucherPhaseGeneration } from '../entities/voucher-phase-generation';

interface ExtraSearchFields {
  fiscalYear?: FiscalYear
  executingUnit?: ExecutingUnit,
  startMonth?: Mhelpdesk,
  endMonth?: Mhelpdesk,

  startDate?: Date,
  endDate?: Date,
  vendorType?: Mhelpdesk,
  vendor?: Vendor,
  employee?: Employee,
  documentType?: DocumentType,
  fisrtDocumentNumber?: string,
  latestDocumentNumber?: string,
  registerNumber?: string,
  certificationNumber?: string,
  phase?: Mhelpdesk
  // flgDeleted ? : boolean
}

@Injectable()
export class VoucherMainService extends BaseCrudService<VoucherMain> {

  public uri = '/api/voucherMain/';

  constructor(injector: Injector) {
    super(injector);
    // console.log('Instance VoucherMainService');
  }

  buildSentence(entity?: VoucherMain, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.fiscalYear ?
          `fiscalYear.id${QueryOperator.Equal}${extraSearchFields.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startMonth && extraSearchFields.endMonth ?
          // tslint:disable-next-line:max-line-length
          `month.code${QueryOperator.Between}${extraSearchFields.startMonth.code}${QueryOperator.Slash}${extraSearchFields.endMonth.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startDate && extraSearchFields.endDate ?
          // tslint:disable-next-line:max-line-length
          `documentDate${QueryOperator.Between}${extraSearchFields.startDate.toISOString()}${QueryOperator.Slash}${extraSearchFields.endDate.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.vendorType ?
          `identifier.id${QueryOperator.Equal}${extraSearchFields.vendorType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.vendor ?
          `vendor.id${QueryOperator.Equal}${extraSearchFields.vendor.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.employee ?
          `employee.id${QueryOperator.Equal}${extraSearchFields.employee.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.documentType ?
          `documentType.id${QueryOperator.Equal}${extraSearchFields.documentType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.fisrtDocumentNumber && extraSearchFields.latestDocumentNumber ?
          // tslint:disable-next-line:max-line-length
          `documentNumber${QueryOperator.Between}${extraSearchFields.fisrtDocumentNumber}${QueryOperator.Slash}${extraSearchFields.latestDocumentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.registerNumber ?
          `voucherMaster.sequentialNumber${QueryOperator.Contain}${extraSearchFields.registerNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.certificationNumber ?
          `certificationNumber${QueryOperator.Equal}${extraSearchFields.certificationNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.phase ?
          `phase.id${QueryOperator.Equal}${extraSearchFields.phase.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    // this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startContractDate');

    return this.httpParams;
  }

  buildSentenceObligation(entity?: VoucherMain, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.fundingPhase ?
          `fundingPhase.id${QueryOperator.Equal}${entity.fundingPhase.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    // this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startContractDate');

    return this.httpParams;
  }

  search2(entity?: VoucherMain, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<VoucherMain>> {

    const url = this.rutaServidor + this.uri;
    this.spinnerService.showAll();
    return this.httpClient.get<ResponsePageable<VoucherMain>>(url, { params: this.buildSentence(entity, event, extraSearchFields) })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.addLogicToSearch(value);
              this.convertToDate(value);
            })
          }
          // console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  searchObligation(entity?: VoucherMain, event?: LazyLoadEvent): Observable<ResponsePageable<VoucherMain>> {

    const url = this.rutaServidor + this.uri;
    this.spinnerService.showAll();
    return this.httpClient.get<ResponsePageable<VoucherMain>>(url, { params: this.buildSentenceObligation(entity, event) })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.addLogicToSearch(value);
              this.convertToDate(value);
            })
          }
          // console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }


  getValidateAmountVoucherLedger(voucherMain: VoucherMain, id: number): Observable<any> {

    const url = `${this.rutaServidor}${this.uri}getValidateAmountVoucherLedger/${id}`;
    return this.httpClient.post<any>(url, voucherMain);
  }


  getValidateAmountVoucherMain(voucherMain: VoucherMain, id: number): Observable<any> {
    const url = `${this.rutaServidor}${this.uri}getValidateAmountVoucherMain/${id}`;
    return this.httpClient.post<any>(url, voucherMain);
  }

  sendToRecaudationVoucher(fy: number, ue: number, voucherMain?: String[]): Observable<any> {
    const rutaServidor = localStorage.getItem('rutaServidor');
    // console.log("rutaServidor :" + rutaServidor);
    const url = rutaServidor + this.uri + 'sendToRecaudationVoucher/' + fy + '/' + ue;
    // console.log("url :" + url);
    return this.httpClient.post(url, voucherMain);
  }

  printDocument(voucherMain?: String[], nameFile?: string): Observable<Blob> {
    const rutaServidor = localStorage.getItem('rutaServidor');
    // console.log("rutaServidor :" + rutaServidor);
    const url = rutaServidor + this.uri + 'printDocument';
    // console.log("url :" + url);
    return this.httpClient.post(url, voucherMain, { responseType: 'blob' })
      .pipe(
        map(res => {
          this.spinnerService.hideAll();
          const bean = new Blob([res], { type: 'application/pdf' });
          FileSaver.saveAs(bean, nameFile);
          return bean;
        }),
        catchError((err) => {
          // console.log("catchError : "  + catchError);
          this.spinnerService.hideAll();
          this.notificationService.serverErrorMessage(err.status + ' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
          return new Observable<Blob>();
        })

      );

  }

  downloadPDF(url: string, object: any, nameFile: string): Observable<Blob> {
    const ruta = this.rutaServidor + this.uri + url;
    this.spinnerService.showAll();
    return this.httpClient.post(ruta, object, { responseType: 'blob' })
      .pipe(
        map(res => {
          this.spinnerService.hideAll();
          const bean = new Blob([res], { type: 'application/pdf' });
          FileSaver.saveAs(bean, nameFile);
          return bean;
        }),
        catchError((err) => {
          // console.log("catchError : "  + catchError);
          this.spinnerService.hideAll();
          this.notificationService.serverErrorMessage(err.status + ' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
          return new Observable<Blob>();
        })

      );

  }

  sendToTransferInterface(fy: number, ue: number, voucherMain?: String[]): Observable<any> {
    const rutaServidor = localStorage.getItem('rutaServidor');
    // console.log("rutaServidor :" + rutaServidor);
    const url = rutaServidor + this.uri + 'sendToTransferInterface/' + fy + '/' + ue;
    // console.log("url :" + url);
    this.spinnerService.showAll();
    return this.httpClient.post(url, voucherMain).pipe(
      tap(response => {
        /*if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
                // debugger;
                this.addLogicToSearch(value);
                this.convertToDate(value);
            })
        }*/
        // console.log(response);
        this.spinnerService.hideAll();
        return response;
      })
    );
  }

  sendToReceiveInterface(fy: number, ue: number, voucherMain?: String[]): Observable<any> {
    const rutaServidor = localStorage.getItem('rutaServidor');
    // console.log("rutaServidor :" + rutaServidor);
    const url = rutaServidor + this.uri + 'sendToReceiveInterface/' + fy + '/' + ue;
    // console.log("url :" + url);
    this.spinnerService.showAll();
    return this.httpClient.post(url, voucherMain).pipe(
      tap(response => {
        /*if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
                // debugger;
                this.addLogicToSearch(value);
                this.convertToDate(value);
            })
        }*/
        // console.log(response);
        this.spinnerService.hideAll();
        return response;
      })
    );
  }

  logicDelete(key: string | number): Observable<any> {
    // debugger;
    const url = this.rutaServidor + this.uri + 'logicDelete/' + key;
    // this.spinnerService.showAll();
    // console.log(url);
    return this.httpClient.get(url);
    /*.pipe(
        tap(response => {
            this.spinnerService.hideAll();
           //console.log(response);
        })
    );
    */
  }

  phaseGenerationVoucher(voucherPhaseGeneration: VoucherPhaseGeneration): Observable<any> {
    const rutaServidor = localStorage.getItem('rutaServidor');
    // console.log("rutaServidor :" + rutaServidor);
    const url = rutaServidor + this.uri + 'sendToPhaseGenerationVoucher';
    // console.log("url :" + url);
    return this.httpClient.post(url, voucherPhaseGeneration);
  }

  phaseGenerationVoucher2(voucherPhaseGeneration: VoucherPhaseGeneration): Observable<any> {
    const rutaServidor = localStorage.getItem('rutaServidor');
    // console.log("rutaServidor :" + rutaServidor);
    const url = rutaServidor + this.uri + 'sendToPhaseGenerationVoucher2';
    // console.log("url :" + url);
    return this.httpClient.post(url, voucherPhaseGeneration);
  }
  
  getDocumentNumberGiro(fiscalYear: FiscalYear): Observable<any> {
    const url = `${this.rutaServidor}${this.uri}documentNumberGiro`;
    return this.httpClient.post<any>(url, fiscalYear);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/voucher-main.service.ts